import { skillsBranchLabels } from '../constants/branch-labels';
import { defineTreeFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const skillDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.SKILL,
    name: 'Skill',
    selectionListIds: ['skill_k75', 'skill_k700', 'skill_k3000'],
    selections: [],
    branches: skillsBranchLabels,
    type: FilterType.TREE,
    isVisible: true,
  },
});
